import styled from 'styled-components';
import { BoxOutline } from '@/general/box/outline';

export const Container = styled(BoxOutline)`
  overflow: visible;
  background: transparent;
`;
